import { render, staticRenderFns } from "./ChangePassword 2.vue?vue&type=template&id=64f23aa2&"
import script from "./ChangePassword 2.vue?vue&type=script&lang=js&"
export * from "./ChangePassword 2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports